<template>
  <div class="page-container">
    <!--工具栏-->
    <el-scrollbar>
      <el-form
        :inline="true"
        :model="filters"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        :size="size"
      >
        <el-form-item label="姓名">
          <el-input
            v-model.trim="filters.userName"
            placeholder="请输入姓名"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input
            v-model.trim="filters.mobileNo"
            placeholder="请输入电话号码"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item label="负责乡镇:">
          <el-select v-model="filters.ownAreaList" multiple placeholder="请选择">
            <el-option
              v-for="item in areaList"
              :key="item.dictName"
              :label="item.dictName"
              :value="item.dictName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-search"
            label="查询"
            type="primary"
            @click="findPage(null)"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-plus"
            label="新增"
            type="warning"
            @click="handleAdd"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-refresh"
            label="刷新"
            type="primary"
            @click="handleRefresh"
          />
        </el-form-item>
      </el-form>
      <div class="filtersposition"></div>
    </el-scrollbar>
    <!--表格内容栏-->
    <kt-table
      v-loading="loading"
      :height="'480'"
      element-loading-text="拼命加载中"
      :data="pageResult"
      :columns="filterColumns"
      :operationWidth="300"
      :showEdit="true"
      :showDelete="true"
      :showLook="false"
      :showResetCode="true"
      :cellStyle="cellStyle"
      @findPage="findPage"
      @handleEdit="handleEdit"
      @handleDelete="handleDelete"
      @handleResetCode="handleResetCode"
      @refreshPageRequest="refreshPageRequest"
      @cellClick="cellClick"
    ></kt-table>

    <!-- 新增服务人员和修改服务人员的dialog模态框-->
    <el-dialog
      class="volunteerdialog"
      :title="operation ? '新增服务人员' : '修改服务人员'"
      width="70%"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="closeDialogReset"
    >
      <el-form
        :model="dataForm"
        label-width="100px"
        :rules="dataFormRules"
        ref="dataForm"
        :size="size"
        label-position="right"
      >
        <el-row>
          <el-col :span="18">
            <el-row>
              <el-col :span="11" :offset="1">
                <el-form-item label="姓名:" prop="userName">
                  <el-input
                    v-model.trim="dataForm.userName"
                    auto-complete="off"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11" :offset="1">
                <el-form-item label="身份证号:" prop="idCard">
                  <el-input
                    v-model.trim="dataForm.idCard"
                    auto-complete="off"
                    placeholder="请输入身份证号"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11" :offset="1">
                <el-form-item label="民族:" prop="nation">
                  <el-select
                    v-model="dataForm.nation"
                    placeholder="请选择民族"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in nationOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="11" :offset="1">
                <el-form-item label="联系电话:" prop="mobileNo">
                  <el-input
                    v-model.trim="dataForm.mobileNo"
                    auto-complete="off"
                    placeholder="请输入联系电话"
                    @change="changeMobileNo"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11" :offset="1">
                <el-form-item label="文化程度:" prop="education">
                  <el-select
                    v-model="dataForm.education"
                    placeholder="请选择文化程度"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in educationoptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="11" :offset="1">
                <el-form-item label="登录账号:" prop="loginName">
                  <el-input
                    v-model="dataForm.loginName"
                    auto-complete="off"
                    :disabled="true"
                    placeholder="请输入登录账号"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-form-item
              label
              prop="headerPic"
              ref="headerPic"
              label-width="0"
            >
              <el-input v-if="false" v-model="dataForm.headerPic"></el-input>
              <div class="rz-picter">
                <!-- <span style="color: red">*</span> -->
                <img :src="avatar" alt class="img-avatar" />
                <input
                  type="file"
                  name="avatar"
                  id="uppic"
                  accept="image/gif, image/bmp, image/jpeg, image/jpg, image/png"
                  @change="changeImage($event)"
                  ref="avatarInput"
                  class="uppic"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :offset="1">
            <el-form-item label="职业类型:" prop="jobType">
              <el-select
                v-model="dataForm.jobType"
                placeholder="请选择职业类型"
                style="width: 100%"
              >
                <el-option
                  v-for="item in professionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="家庭住址:" prop="ownArea">
              <el-input
                v-model.trim="dataForm.ownArea"
                auto-complete="off"
                placeholder="请输入家庭住址"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="服务区域:" prop="serviceArea">
              <el-input
                v-model.trim="dataForm.serviceArea"
                auto-complete="off"
                placeholder="请输入服务区域"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :offset="1">
            <el-form-item label="服务区域:" prop="address">
              <el-input
                v-model.trim="dataForm.address"
                auto-complete="off"
                placeholder="请输入服务区域"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="服务技能:" prop="skill">
              <el-input
                v-model.trim="dataForm.skill"
                auto-complete="off"
                placeholder="请输入服务技能"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="个人说明:" prop="remark">
              <el-input
                v-model.trim="dataForm.remark"
                type="textarea"
                :rows="2"
                auto-complete="off"
                placeholder="请输入个人说明"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          :size="size"
          type="primary"
          :disabled="submitDisabled"
          @click.native="submitForm"
          :loading="editLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 重置密码的dialog模态框-->
    <!-- <el-dialog
      title="重置密码"
      width="30%"
      :visible.sync="dialogVisibleCode"
      :close-on-click-modal="false"
      @close="closeDialogResetCode"
    >
      <el-form
        :model="codeDataForm"
        label-width="100px"
        :rules="codeDataFormRules"
        ref="codeDataForm"
        :size="size"
        label-position="right"
      >
        <el-form-item label="密码:" prop="password">
          <el-input
            v-model.trim="codeDataForm.password"
            auto-complete="off"
            placeholder="请输入密码"
            style="width:80%;"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码:" prop="confirmPwd">
          <el-input
            v-model.trim="codeDataForm.confirmPwd"
            auto-complete="off"
            placeholder="请输入确认密码"
            style="width:80%;"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleCode = false">取消</el-button>
        <el-button
          :size="size"
          type="primary"
          @click.native="submitFormCode"
          :loading="codeLoading"
        >确定</el-button>
      </div>
    </el-dialog> -->

    <el-dialog
      title="重置密码"
      width="30%"
      :visible.sync="passDialogFormVisible"
      :close-on-click-modal="false"
      @close="closeDialogResetCode"
    >
      <el-form
        :model="codeDataForm"
        label-width="100px"
        :rules="codeDataFormRules"
        ref="codeDataForm"
        :size="size"
        label-position="right"
      >
        <el-form-item label="密码:" prop="password">
          <el-input
            v-model="codeDataForm.password"
            auto-complete="off"
            placeholder="请输入密码"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码:" prop="confirmPwd">
          <el-input
            v-model="codeDataForm.confirmPwd"
            auto-complete="off"
            placeholder="请输入确认密码"
            style="width: 80%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="passDialogFormVisible = false"
          >取消</el-button
        >
        <el-button :size="size" type="primary" @click.native="submitFormCode"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 查看上下线的dialog模态框 -->
    <el-dialog
      :title="personnelTitle"
      :visible.sync="upDownRecordDialogVisible"
      width="40%"
      :center="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span>
        <el-table
          :data="upDownRecordList"
          :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column
            type="index"
            label="序号"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="statusChangeTime"
            label="状态变更时间"
            align="center"
          ></el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1" style="color: green"
                >在线</span
              >
              <span v-else style="color: red">离线</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          background
          layout="total,prev, pager, next,jumper"
          :total="recordTotal"
          align="center"
          class="fenye"
          @current-change="recordChangePage"
          :current-page="logPageNum"
        ></el-pagination>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="upDownRecordDialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
import util from "@/utils/util.js";
export default {
  components: {
    KtTable,
    KtButton,
  },
  data() {
    var validateOldId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("身份证号不能为空"));
      } else {
        //by guo 2019-3-28    添加15 和18位的身份证验证年月日合法
        var re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
        //also re = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
        var arrSplit = value.match(re); //检查生日日期是否正确  18位
        var re2 = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
        var arrSplit2 = value.match(re2); //检查生日日期是否正确  15位
        if (arrSplit != null) {
          var check18 = util.formatDate.YearMonthDayValidate(
            arrSplit[2],
            arrSplit[3],
            arrSplit[4]
          );
          console.log(check18);
        }
        if (arrSplit2 != null) {
          if (parseInt(arrSplit2[2].substr(1)) > 0) {
            arrSplit2[2] = "19" + arrSplit2[2];
          } else {
            arrSplit2[2] = "20" + arrSplit2[2];
          }
          var check15 = util.formatDate.YearMonthDayValidate(
            arrSplit2[2],
            arrSplit2[3],
            arrSplit2[4]
          );
          console.log(check15);
        }

        //  老身份证15位  新身份证18位(最后一位可以使x)
        var reg = /^(\d{15}|\d{17}[xX\d])$/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的身份证号码"));
        } else if (check18 == false || check15 == false) {
          //by guo 2019-3-28 添加
          callback(new Error("出生日期不准确"));
        } else {
          callback();
        }
      }
    };
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      } else {
        //  因为现在新增了166、198、199号段的手机号
        var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
        if (!reg.test(value)) {
          callback(new Error("手机号码格式错误"));
        } else {
          callback();
        }
      }
    };
    var validateEgPhone = (rule, value, callback) => {
      if (value != "") {
        var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("手机号码格式错误"));
        }
      } else {
        callback();
      }
    };
    var validatePic = (rule, value, callback) => {
      if (this.filePic || this.avatar != require("@/assets/common/jia.png")) {
        callback();
      } else {
        callback(new Error("请上传图片"));
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.codeDataForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      filePic: "", //图片文件
      id: "", //重置密码需要的id
      loading: true,
      picture: "picture", //上传的文件格式
      bucketName: "cmny-oss", //七牛云bucket
      avatar: require("@/assets/common/jia.png"),
      nationOptions: [], //民族
      educationoptions: [], //教育
      professionOptions: [], //职业类型
      size: "medium", //按钮的尺寸
      filters: {
        //工具栏的form表单的属性值
        userName: "",
        mobileNo: "",
        ownAreaList:[],
      },
      columns: [], //table列的集合
      areaList:[],
      filterColumns: [],
      pageRequest: { pageNum: 1, pageSize: 10 }, //默认分页
      pageResult: {},
      dataForm: {
        userName: "",
        nation: "",
        idCard: "",
        mobileNo: "",
        education: "",
        loginName: "",
        headerPic: "",
        jobType: "",
        address: "",
        skill: "",
        ownArea: "",
        serviceArea: "",
        remark: "",
      }, //新增和修改
      operation: false, // true:新增, false:编辑
      dialogVisible: false, // 新增编辑界面是否显示
      editLoading: false, //修改loading
      dataFormRules: {
        userName: [
          { required: true, message: "不能为空", trigger: "blur" }, //是否必填 //规则  //何事件触发
          //可以设置双重验证标准
          { min: 2, max: 10, message: "长度在 2到 10 的中文字符" },
          { pattern: /^[\u4e00-\u9fa5]+$/, message: "请输入由中文组成的字符" },
        ],
        idCard: [{ required: true, validator: validateOldId, trigger: "blur" }],
        nation: [{ required: true, message: "不能为空", trigger: "change" }],
        mobileNo: [
          { required: true, trigger: "blur" },
        ],
        education: [{ required: true, message: "不能为空", trigger: "change" }],
        jobType: [
          { required: true, message: "不能为空", trigger: "change" },
          /*修改需求,先注释*/
          // {required: true, message: '不能为空', trigger: 'blur'},
          // { min: 1, max:20,  message: '长度在 1到 20 个字符', }
        ],
        loginName: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "请输入由数字或者字母组成的字符",
          },
          { min: 5, max: 12, message: "长度在 5到 12 个字符" },
        ],
        ownArea: [{ min: 0, max: 20, message: "长度在 0到 20 个字符" }],
        serviceArea: [{ min: 0, max: 20, message: "长度在 0到 20 个字符" }],
        address: [{ min: 0, max: 30, message: "长度在 0到 30 个字符" }],
        skill: [{ min: 0, max: 30, message: "长度在 0到 30 个字符" }],
        remark: [{ min: 0, max: 50, message: "长度在 0到 50 个字符" }],
      },
      codeDataForm: {}, //重置密的form表单数据
      passDialogFormVisible: false, //密码重置弹窗
      dialogVisibleCode: false, //重置密码的dialog显示和隐藏
      codeLoading: false, //重置密码的loading
      codeDataFormRules: {
        password: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "请输入由数字或者字母组成的字符",
          },
          { min: 6, max: 16, message: "长度在 6到 16 个字符" },
        ],
        confirmPwd: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "请输入由数字或者字母组成的字符",
          },
          { min: 6, max: 16, message: "长度在 6到 16 个字符" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      pickerBirthday: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      groupId: "",
      submitDisabled: true,

      //服务人员上下线记录的dialog模态框
      upDownRecordDialogVisible: false,
      personnelTitle: "人员上下线记录",
      logPageNum: 1,
      recordTotal: 0,
      upDownRecordList: [], //服务人员上下线集合

      //服务人员上下线记录的分页
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 8, //每页显示的条数
      totalDataNumber: 0, //总条数
    };
  },
  methods: {
    //清除校验
    clearValidate(formName) {
      //formName为传入要清除的prop ，可以是整个form表单，也可以是一个
      this.$refs[formName].clearValidate();
    },
    // 刷新
    handleRefresh() {
      this.filters = {}; //清空查询条件
      this.findPage();
    },
    //关闭新增和修改服务人员的dialog清除验证
    closeDialogReset() {
      document.getElementById("uppic").value = ""; //每次关闭dialog框都清空上传文件file的值，以防再次打开选择相同的不能触发change时间
      this.filePic = ""; //清空上传的图片文件
      this.avatar = require("@/assets/common/jia.png"); //清空上传的图片显示
      this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
    },
    changeMobileNo(val) {
      console.log(val);
      this.dataForm.loginName = this.dataForm.mobileNo;
      console.log(this.dataForm.loginName);
    },
    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.findPage();
      }
    },
    // 获取分页数据
    findPage(data) {
      console.log(data);
      //判断查询条件是否存在
      this.filters.userName != undefined
        ? (this.pageRequest.userName = this.filters.userName)
        : (this.pageRequest.userName = "");
      this.filters.mobileNo != undefined
        ? (this.pageRequest.mobileNo = this.filters.mobileNo)
        : (this.pageRequest.mobileNo = "");
        
      if(this.filters.ownAreaList!=null && this.filters.ownAreaList.length>0){
        this.pageRequest.ownAreaList = this.filters.ownAreaList;
      }
      console.log(this.pageRequest);
      this.$postJson("uac/staff/selectStaffByNotSpecoalist", this.pageRequest)
        .then((res) => {
          console.log(res.result);
          res.result.list.forEach((item) => {
            item.gender == 0 ? (item.sex = "男") : (item.sex = "女");
            // item.status='offline';
            // item.statusText= '离线';
            item.status == 0
              ? (item.statusText = "离线")
              : (item.statusText = "在线");
          });
          this.pageResult = res.result; //将值赋给this.pageResult这个对象
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .then(data != null ? data.callback : "");
    },
    // 分页刷新数据
    refreshPageRequest(data) {
      console.log(data);
      this.pageRequest.pageNum = data;
      this.findPage();
    },
    // 删除
    handleDelete(data) {
      console.log(data.params[0].id, data.callback);
      let staffId = data.params[0].id;
      console.log(staffId);
      this.$postForm("uac/staff/deleteById/" + staffId).then((res) => {
        console.log(res);
        var info = res;
        data.callback(info);
      });
    },

    // 显示新增界面
    handleAdd() {
      this.dialogVisible = true;
      this.operation = true;
      this.avatar = require("@/assets/common/jia.png");
      this.submitDisabled = true;
    },
    // 显示编辑界面
    handleEdit(params) {
      this.dialogVisible = true;
      this.operation = false;
      this.submitDisabled = false;
      this.$nextTick(() => {
        this.dataForm = Object.assign({}, params.row);
        this.avatar = this.dataForm.headerPic;
      });
    },
    //校验只能上传jpg和png格式的图片
    beforeUpload(file) {
      //图片上传之前校验
      console.log(file, "-----------------------进来了");
      if (file != undefined) {
        let isPNG = false;
        let isImage = false;
        file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
        if (
          file.type == "image/bmp" ||
          file.type == "image/jpeg" ||
          file.type == "image/jpg" ||
          file.type == "image/png"
        ) {
          isImage = true;
        } else {
          isImage = false;
        }
        const isLt2048k = file.size / 1024 < 2048;
        if (!isPNG) {
          this.$message.error("上传图片格式不能是 gif 格式");
          return false;
        }
        if (!isImage) {
          this.$message.error("上传格式错误");
          return false;
        }
        if (!isLt2048k) {
          this.$message.error("上传图片大小不能超过 2Mb");
          return false;
        }
        console.log(isPNG, isLt2048k);
        return isPNG && isLt2048k && isImage;
      }
    },
    //上传图片
    changeImage(e) {
      console.log(e);
      this.filePic = e.target.files[0];
      console.log(this.filePic, "this.filePic");
      if (this.filePic) {
        //判断图片文件是否存在
        this.dataForm.headerPic = "0"; //当选择了图片，暂时给input框一个，防止点确定的时候，图片还没上上传成功，会提示不能为空的红色错误提示框
        this.clearValidate("headerPic"); // 清除gitPic的校验
      }
      var file = e.target.files[0];
      console.log(file);
      //console.log(this.beforeUpload(file))
      if (this.beforeUpload(file)) {
        var reader = new FileReader();
        var that = this;
        if (file != undefined) {
          reader.readAsDataURL(file);
          reader.onload = function () {
            console.log(this.result);
            that.avatar = this.result;
          };
          let params = new FormData();
          params.append("file", file);
          params.append("fileType", this.picture);
          params.append("bucketName", this.bucketName);
          console.log(params);
          this.$postFormData("dmc/file/uploadFile", params).then(res => {
            this.dataForm.headerPic = res.result;
            document.getElementById("uppic").value = "";
            this.submitDisabled = false;
          });
        }
      } else {
        document.getElementById("uppic").value = ""; //每次关闭dialog框都清空上传文件file的值，以防再次打开选择相同的不能触发change时间
      }
    },
    deleteUserName() {
      this.filters.userName = "";
    },
    deleteMobileNo() {
      this.filters.mobileNo = "";
    },
    // 新增和编辑提交数据
    submitForm() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          let params = Object.assign({}, this.dataForm);
          var date = new Date();
          var yearfull = date.getFullYear();
          var IdCardNO = this.dataForm.idCard;
          if (IdCardNO.length == 18) {
            var birthyear = IdCardNO.substring(6, 10);
            var age = yearfull - birthyear;
            params.age = age;
            console.log(parseInt(IdCardNO.substring(17, 1)));
            if (parseInt(IdCardNO.substring(17, 1)) % 2 == 1) {
              //男
              params.gender = 0;
            } else {
              //女
              params.gender = 1;
            }
          } else if (IdCardNO.length == 15) {
            var birthDay = IdCardNO.substring(6, 12);
            birthDay = "19" + birthDay;
            birthDay = birthDay.substring(0, 4);
            var age = yearfull - birthDay;
            params.age = age;
            if (parseInt(IdCardNO.substring(14, 1), 10) % 2 == 1) {
              //男
              params.gender = 0;
            } else {
              //女
              params.gender = 1;
            }
          }
          console.log(this.operation, params);
          //this.operation==true为新增的url  this.operation==false为修改的url
          let url = "";
          if (this.operation) {
            url = "uac/staff/add";
            params.groupId = this.groupId;
          } else {
            url = "uac/staff/edit";
          }
          console.log(url);
          this.$postJson(url, params).then((res) => {
            console.log(res);
            this.editLoading = false;
            if (res.code == 200) {
              this.$message({ message: "操作成功", type: "success" });
              this.dialogVisible = false;
              this.$refs["dataForm"].resetFields();
            } else {
              this.$message({
                message: "操作失败, " + res.message,
                type: "error",
              });
            }
            this.findPage();
          });
        }
      });
    },
    //查看详情
    handleLook(data) {
      console.log(data);
      let userId = data.row.userId;
      let headerPic = data.row.headerPic;
      console.log(userId);
      this.$router.push({
        path: "/volunteerdetail",
        query: { userId: userId, headerPic: headerPic },
      }); //编程式导航跳转  query传参
    },
    //关闭重置密码的dialog框
    closeDialogResetCode() {
      this.$refs.codeDataForm.resetFields(); //移除校验结果并重置字段值
    },
    //重置密码弹出模态框
    handleResetCode(data) {
      console.log(data);
      this.id = data.row.id;
      this.dialogVisibleCode = true;
      this.passDialogFormVisible = true;
      console.log(this.id);
    },
    //重置密码提交数据
    submitFormCode() {
      this.$refs.codeDataForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.codeLoading = true;
            let params = Object.assign({}, this.codeDataForm);
            params.id = this.id;
            console.log(params);
            this.$postJson("uac/staff/modifyPwd", params).then((res) => {
              console.log(res);
              this.codeLoading = false;
              if (res.code == 200) {
                this.$message({ message: "操作成功", type: "success" });
                this.dialogVisibleCode = false;
                this.passDialogFormVisible = false;
                this.$refs["codeDataForm"].resetFields();
              } else {
                this.$message({
                  message: "操作失败, " + res.message,
                  type: "error",
                });
              }
              this.findPage();
            });
          });
        }
      });
    },
    recordChangePage(val) {
      console.log(val);
      this.logPageNum = val;
      var params = {
        staffId: this.logId,
        pageSize: 10,
        pageNum: this.logPageNum,
      };
      this.$postJson("uac/staff/getStatusLog", params).then((res) => {
        this.upDownRecordList = res.result.list;
        this.recordTotal = Number(res.result.total);
      });
    },
    //上下线记录
    cellClick(data) {
      //点击的column label为 上下线记录才弹出人员上下线记录的模态框
      if (data.column.label == "上下线状态") {
        console.log(data, data.row.id);
        this.logPageNum = 1;
        var id = data.row.id;
        this.logId = data.row.id;
        // var id = data.row.userId;
        this.upDownRecordDialogVisible = true;
        // uac/staff/getStatusLog
        var params = {
          staffId: id,
          pageSize: 10,
          pageNum: this.logPageNum,
        };
        this.$postJson("uac/staff/getStatusLog", params).then((res) => {
          this.upDownRecordList = res.result.list;
          this.recordTotal = Number(res.result.total);
        });
      }
    },
    //初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      //调取列表接口
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      //调取列表接口
    },
    /* 
      修改table tr行的背景色
    */
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #e4f5f8";
      } else {
        return "background-color: #f9f9f9";
      }
    },

    /* 
      修改单元格的字体颜色
    */
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label == "上下线状态") {
        if (row.status == 0) {
          return "color: red";
        } else {
          return "color:green";
        }
      }
    },

    /* 
      修改table header的背景色
    */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#bee1f4;color:#6f7075;font-weight: 500;";
      }
    },

    // 时间格式化
    dateFormat: function (row, column, cellValue, index) {
      return format(row[column.property]);
    },
    // 处理表格列过滤显示
    displayFilterColumnsDialog: function () {
      this.$refs.tableColumnFilterDialog.setDialogVisible(true);
    },
    // 处理表格列过滤显示
    handleFilterColumns: function (data) {
      this.filterColumns = data.filterColumns;
      this.$refs.tableColumnFilterDialog.setDialogVisible(false);
    },
    // 处理表格列过滤显示
    initColumns: function () {
      this.columns = [
        { prop: "userName", label: "姓名", minWidth: 100 },
        { prop: "sex", label: "性别", minWidth: 80 },
        { prop: "mobileNo", label: "联系电话", minWidth: 120 },
        { prop: "address", label: "负责区域", minWidth: 100 },
        { prop: "idCard", label: "身份证号", minWidth: 120 },
        { prop: "loginName", label: "登录账号", minWidth: 120 },
        // { prop: "statusText", label: "上下线状态", minWidth: 120 },
      ];
      this.filterColumns = JSON.parse(JSON.stringify(this.columns));
    },

    // 初始化民族
    initialNations() {
      var nations = [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
      ];
      for (var i = 0; i < nations.length; i++) {
        var item = {};
        //item.value = i
        item.value = nations[i];
        item.label = nations[i];
        this.nationOptions.push(item);
      }
    },
    //初始化文化程度
    initialEducations() {
      var educations = [
        "文盲",
        "小学",
        "初中",
        "高中",
        "大专",
        "本科",
        "硕士",
        "博士",
      ];
      for (var i = 0; i < educations.length; i++) {
        var item = {};
        // item.value = i
        item.value = educations[i];
        item.label = educations[i];
        this.educationoptions.push(item);
      }
    },
    //初始化职业类型
    initialProfessionOptions() {
      var professions = [
        "企业职工",
        "教师",
        "医护工作者",
        "自由职业者",
        "演员",
        "其他",
      ];
      for (var i = 0; i < professions.length; i++) {
        var item = {};
        //item.value = i
        item.value = professions[i];
        item.label = professions[i];
        this.professionOptions.push(item);
      }
    },
    getAreaList(){
      this.$postJson('mdc/dict/queryDictSubListByDictCode/area_' +  this.groupId).then(res=>{
        this.areaList = res.result;
      })
    }
  },
  created() {
    this.groupId = sessionStorage.getItem("groupId");
    this.initialNations();
    this.initialEducations();
    this.initialProfessionOptions();
    this.getAreaList();
  },
  mounted() {
    this.initColumns();
    this.findPage();
  },
};
</script>

<style lang="scss" scoped>
.rz-picter {
  width: 100%;
  height: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.rz-picter:hover {
  border-color: #409eff;
}
.img-avatar {
  width: 140px;
  height: 140px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.uppic {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  opacity: 0;
}
// ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: center;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
//新增 编辑 dialog
@media screen and (max-width: 1599px) {
  ::deep .volunteerdialog .el-dialog {
    width: 80% !important;
  }
}
::deep .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  width: 100.5%;
  height: 100%;
}
::deep .el-form--inline {
  position: relative;
  z-index: 99;
}
.filtersposition {
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  bottom: 10px;
  width: 100%;
  height: 56px;
  background: #f2f2f2;
  z-index: 1;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
</style>